import { useEffect, useState } from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    Form,
    Input,
    Label,
    Button
} from 'reactstrap';
import "./AddUser.scss"

const AddUser = ({ setIsUserModalActive, setUser, users, setPointsStrucutre, pointsStructure }) => {
    const [tempState, setTempState] = useState({ name: '' });

    const createPointsStructure = () => {
        const pointsStructure = {
            'ania&kuba': { name: 'Ania i Kuba', value: 0 },
            'mama&tata': { name: 'Mama i Tata', value: 0 },
            'weronika': { name: 'Weronika', value: 0 },
            'domek': { name: 'Domek', value: 0 },
            'natalia': { name: 'Natalia', value: 0 },
            'zosia': { name: 'Zosia', value: 0 },
            'bartek': { name: 'Bartek', value: 0 },
            'muszka&koko': { name: 'Muszka i Koko', value: 0 },
            'dija': { name: 'Dija', value: 0 },
            'rodzinka': { name: 'Rodzinka', value: 0 },
        }

        return pointsStructure;
    }

    const handleSubmit = () => {
        setUser([...users, tempState])
        setPointsStrucutre({ ...pointsStructure, [tempState.name]: createPointsStructure() })
        setIsUserModalActive(false)
    }

    const handleChange = (name, value) => {
        setTempState({ ...tempState, [name]: value })
    }

    return (
        <>
            <Modal isOpen={true} toggle={(value) => { setIsUserModalActive(false); console.log(value) }}>
                <ModalHeader toggle={(value) => { setIsUserModalActive(false); console.log(value) }}>
                    Dodaj gracza
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(handleSubmit)}>
                        <Label>Nazwa:</Label>
                        <Input type="text" placeholder="Nazwa" name='name' className='mb-3' onChange={e => { handleChange(e.target.name, e.target.value) }} />

                        <div className='d-flex justify-content-end'>
                            <Button type="submit" className='mt-5' onClick={e => { e.preventDefault(); handleSubmit() }}>Dodaj</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </>

    )

}

export default AddUser;